import api from "./api";

// 删除agent用户素材
export const deleteAgentUserMaterialFolder = async ({
  agentId,
  userId,
  type,
  folderId,
}: {
  agentId: string;
  userId: string;
  type: number;
  folderId: number;
}) => {
  const res = await api.post<unknown>("/user_material/delete_agent_user_material_folder", {
    agent_id: agentId,
    user_id: userId,
    type: type,
    folder_id: folderId,
  });
  return res;
};
